import { render, staticRenderFns } from "./ExperienceDetail.vue?vue&type=template&id=32a22494&scoped=true"
import script from "./ExperienceDetail.vue?vue&type=script&lang=js"
export * from "./ExperienceDetail.vue?vue&type=script&lang=js"
import style0 from "./ExperienceDetail.vue?vue&type=style&index=0&id=32a22494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a22494",
  null
  
)

export default component.exports